import { FC } from 'react';

export const Dot: FC<{ className?: string }> = ({ className = '' }) => (
  <div
    className={`flex-shrink-0 rounded-full bg-berry w-2 h-2 absolute right-2 top-2 ${className}`}
  />
);
